import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DipStateService } from './../services/dip-state-service.service';
import * as _ from 'lodash-es';
import numeral from 'numeral';
import moment from 'moment';

@Component({
    selector: 'recap-property-details',
    templateUrl: './recap-property-details.component.html',
    styleUrls: ['./recap-property-details.component.scss'],
    standalone: false
})
export class RecapPropertyDetailsComponent implements OnInit {
    /**
    * Event emitted to tell the parent to invoke the edit action
    *
    * @type {EventEmitter<string>}
    * @memberof RecapPropertyDetails
    */
    @Output() stageChange: EventEmitter<string>;
    /**
    * Incoming property details data form the parent
    *
    * @type {Object}
    * @memberof RecapPropertyDetails
    */
    @Input() propertyDetails: Object;
    /**
    * Flag to togle displaying the edit button
    *
    * @type {boolean}
    * @memberof RecapPropertyDetails
    */
    @Input() showEditButton: boolean;
    /**
     * formatted addresss
     *
     * @readonly
     * @memberof RecapPropertyDetailsComponent
     */
    get Address() {
        if (_.isEmpty(this.propertyDetails)) {
            return;
        }
        return _.defaultTo(this.propertyDetails['FullAddress'], '');
    }
    /**
     * Number of bedrooms
     *
     * @readonly
     * @memberof RecapPropertyDetailsComponent
     */
    get Bedrooms() {
        if (_.isEmpty(this.propertyDetails)) {
            return;
        }
        return _.defaultTo(this.propertyDetails['NumberOfBedrooms'], '');
    }
    /**
     * Auciton house name
     *
     * @readonly
     * @memberof RecapPropertyDetailsComponent
     */
    get AuctionHouse() {
        if (_.isEmpty(this.propertyDetails) || _.isEmpty(this.propertyDetails['AuctionHouse'])) {
            return 'Auction house not given';
        }

        return _.defaultTo(this.propertyDetails['AuctionHouse'], 'Auction house not given');
    }
    /**
     * Formatted date of auction
     *
     * @readonly
     * @memberof RecapPropertyDetailsComponent
     */
    get AuctionDate() {
        if (_.isNil(this.propertyDetails)
            || _.isNil(this.propertyDetails['AuctionDate'])) {
            return 'Auction date not given';
        }
        return moment(_.defaultTo(this.propertyDetails['AuctionDate'], null)).format('DD/MM/YYYY');
    }

    /**
     *
     * @readonly
     * @memberof RecapPropertyDetailsComponent
     */
    get Valuation() {
        if (_.isEmpty(this.propertyDetails)) {
            return;
        }

        const value = _.toInteger(this.propertyDetails['Valuation']);
        return '£' + numeral(value).format('0,0');
    }

    /**
     *
     * @readonly
     * @memberof RecapPropertyDetailsComponent
     */
    get PropertyType() {
        if (_.isEmpty(this.propertyDetails)) {
            return;
        }

        return this.propertyDetails['PropertyType'];
    }

    /**
     * Is this a dip journey?
     *
     * @readonly
     * @memberof RecapPropertyDetailsComponent
     */
    get isDip() {
        return this.state.isDipJourney.getValue() && this.state.propertyType.getValue() === 0;
    }

    /**
     * Creates an instance of RecapPropertyDetails.
     * @memberof RecapPropertyDetails
     */
    constructor(private state: DipStateService) {
        this.stageChange = new EventEmitter<string>();
    }

    /**
     * Initialise the component
     *
     * @memberof RecapLoanDetailsComponent
     */
    ngOnInit() {
    }
    /**
     * emit stage change when edit button clicked
     *
     * @memberof RecapLoanDetailsComponent
     */
    editButtonClicked(): void {
        this.stageChange.emit('tad_stage_property_details');
    }
}
